import { RGBColor, RGBColorType } from '../../types/types';

export type PaletteColors = {
  paletteBackgroundColor: string;
  paletteTextColor: string;
};

export const extractPaletteColors = (palette: RGBColor[]): PaletteColors => {
  const paletteColors: PaletteColors = {
    paletteBackgroundColor: '',
    paletteTextColor: '',
  };

  palette?.forEach(rgbColor => {
    switch (rgbColor.type) {
      case RGBColorType.GradientBackground:
        paletteColors.paletteBackgroundColor = `linear-gradient(180deg,` + rgbColor.rgb1 + ` 0%,` + rgbColor.rgb2 + ` 100%)`;
        break;
      case RGBColorType.SolidBackground:
        paletteColors.paletteBackgroundColor = rgbColor.rgb1;
        break;
      case RGBColorType.Text:
        paletteColors.paletteTextColor = rgbColor.rgb1;
        break;
    }
  });

  return paletteColors;
};
